import { ORDER_STATUS } from "utils/helpers/enums/roles.enum";

export class OrderRequestFilterDTO {
  page: number = 1;
  limit: number = 10;
  count: number = 1;
  size: number = 10;
  ambassadorName: string = "";
  status: ORDER_STATUS = ORDER_STATUS.PENDING;
}
